import { render, staticRenderFns } from "./Consumption.vue?vue&type=template&id=aed4cbd0&scoped=true"
import script from "./Consumption.vue?vue&type=script&lang=js"
export * from "./Consumption.vue?vue&type=script&lang=js"
import style0 from "./Consumption.vue?vue&type=style&index=0&id=aed4cbd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed4cbd0",
  null
  
)

export default component.exports